import React from 'react';
import { FaHome, FaHandshake, FaChartLine } from 'react-icons/fa';

const features = [
    {
        id: 1,
        icon: <FaHome className="w-5 h-5" />,
        title: 'Find Your Dream Home',
        description: 'Discover properties that match your lifestyle and budget with our advanced search tools.'
    },
    {
        id: 2,
        icon: <FaHandshake className="w-5 h-5" />,
        title: 'Competitive Pricing',
        description: 'Get the best value with our competitive pricing and market analysis.'
    },
    {
        id: 3,
        icon: <FaChartLine className="w-5 h-5" />,
        title: 'Prime Locations',
        description: 'Explore properties in the most sought-after neighborhoods and communities.'
    }
];

const SellingOptions = () => {
    return (
        <section className="py-12 md:py-16 lg:py-24 bg-gradient-to-b from-blue-50 to-white font-poppins overflow-hidden">
            <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-7xl">
                <div className="flex flex-col lg:flex-row items-center gap-12 xl:gap-20">
                    {/* Left: Image */}
                    <div className="w-full lg:w-1/2 relative">
                        <div className="relative rounded-2xl overflow-hidden shadow-xl">
                            <img
                                src="assets/images/selling-image.jpg"
                                alt="Modern house with beautiful architecture"
                                className="w-full h-auto rounded-2xl"
                                loading="lazy"
                            />
                            <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent opacity-0 flex items-end p-8">
                                <div className="text-white">
                                    <h3 className="text-2xl font-bold mb-2">Your Dream Home Awaits</h3>
                                    <p>Discover properties that match your lifestyle and budget</p>
                                </div>
                            </div>
                        </div>
                        
                        {/* Decorative Elements */}
                        {/* <div className="hidden lg:block absolute -left-10 -bottom-10 w-40 h-40 bg-blue-100 rounded-full -z-10"></div>
                        <div className="hidden lg:block absolute -right-10 top-1/2 w-32 h-32 bg-yellow-100 rounded-full -z-10"></div> */}
                    </div>

                    <div className="w-full lg:w-1/2">
                        <div className="max-w-lg">
                            <span className="inline-block text-blue-600 text-sm font-semibold mb-3 px-3 py-1 bg-blue-50 rounded-full">
                                Our Competitive Edge
                            </span>
                            <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-gray-900 mb-6 leading-tight">
                                Your Dream Home Awaits
                            </h2>
                            <p className="text-gray-600 text-lg mb-8 leading-relaxed">
                                Discover exceptional properties tailored to your lifestyle. Our expert team combines market knowledge with personalized service to help you make informed real estate decisions.
                            </p>

                            {/* Features List */}
                            <ul className="space-y-4">
                                {features.map((feature) => (
                                    <li key={feature.id} className="flex items-start">
                                        <span className="flex-shrink-0 flex items-center justify-center w-10 h-10 rounded-full bg-blue-100 text-blue-600 mr-4">
                                            {feature.icon}
                                        </span>
                                        <div>
                                            <h3 className="text-lg font-semibold text-gray-900">{feature.title}</h3>
                                            <p className="text-gray-600">{feature.description}</p>
                                        </div>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default SellingOptions;
